import React from "react";
import { connect } from "react-redux";
import Select from 'react-select';

import "./EditExternalEmployees.css"

import { getAllUsers } from "../../../../../actions/userActions"
import { getExternalUnit, editExternalUnitEmployees } from "../../../../../actions/externalUnitActions";

class EditExternalEmployees extends React.Component {
    constructor(props) {
        super(props);

        this.initialState = {
            addOperations: {},
            deleteOperations: {}
        };
        this.state = this.initialState;
    }

    componentDidMount() {
        this.props.getAllUsers();
        this.props.getExternalUnit(this.props.match.params.externalOuID);
    }

    onNewChange = (userID, value) => {
        if (userID !== null) this.setState({ addOperations: { ...this.state.addOperations, [userID]: null, [value.value.userID]: value.value } });
        else this.setState({ addOperations: { ...this.state.addOperations, [value.value.userID]: value.value } });
    }

    onRowDelete = (user) => {
        this.setState({ deleteOperations: { ...this.state.deleteOperations, [user.userID]: this.state.deleteOperations[user.userID] ? null : user } });
    };

    onNewDelete = (userID) => {
        this.setState({ addOperations: { ...this.state.addOperations, [userID]: null } });
    };

    onChangesApply = () => {
        const formValues = {
            addOperations: [...Object.keys(this.state.addOperations).map(key => this.state.addOperations[key] ? this.state.addOperations[key].userID : null).filter(v => v !== null)],
            deleteOperations: [...Object.keys(this.state.deleteOperations).map(key => this.state.deleteOperations[key] ? this.state.deleteOperations[key].userID : null).filter(v => v !== null)]
        };
        this.props.editExternalUnitEmployees(this.props.match.params.externalOuID, formValues, this.onChangeSuccess);
    };

    onChangeSuccess = () => this.setState(this.initialState);

    renderRows = () => this.props.externalUnit.employees.map(employee => {
        return (
            <div key={employee.userID} className={`ui ${this.state.deleteOperations[employee.userID] ? "secondary red " : ""}segment`}>
                {this.renderRow(employee, false)}
            </div>
        );
    });

    renderNewRows = () => Object.keys(this.state.addOperations).map(key => {
        return (this.state.addOperations[key] ? (
            <div key={key} className="ui secondary green segment">
                {this.renderRow(this.state.addOperations[key], true)}
            </div>
        ) : <React.Fragment key={key} />);
    });

    renderRow = (employee, isNew) => {
        return (
            <div className={`ui ${employee ? "" : "header "}grid`}>
                {employee && isNew ? (
                    <div className="row">
                        <div className="four wide normal overflow column">
                            <Select
                                value={{ label: `${employee.lname} ${employee.fname}`, value: employee.userID }}
                                onChange={value => this.onNewChange(employee.userID, value)}
                                options={[...this.props.usersList.map(u => { return { label: `${u.lname} ${u.fname}`, value: u } })]}
                                placeholder="Użytkownik"
                                noOptionsMessage={() => "Nie znaleziono użytkowników"}
                                maxMenuHeight="400px"
                            />
                        </div>
                    </div>
                ) : null}
                <div className="row">
                    <div className="four wide column">
                        <div className="content">{employee ? employee.userID : "Numer ewidencyjny"}</div>
                    </div>
                    <div className="four wide column">
                        <div className="content">{employee ? `${employee.lname} ${employee.fname}` : "Nazwisko i imię"}</div>
                    </div>
                    <div className="four wide column">
                        <div className="content">{employee ? employee.email : "Email"}</div>
                    </div>
                    <div className="four wide column">
                        {employee ? (
                            <button className="ui button" onClick={() => isNew ? this.onNewDelete(employee.userID) : this.onRowDelete(employee)}>{isNew ? "Anuluj" : this.state.deleteOperations[employee.userID] ? "Cofnij" : "Usuń"}</button>
                        ) : null}
                    </div>
                </div>
            </div>
        )
    };

    renderChanges = () => {
        const changes = [
            ...Object.keys(this.state.addOperations).map(key => this.renderChange(this.state.addOperations[key], "add")),
            ...Object.keys(this.state.deleteOperations).map(key => this.renderChange(this.state.deleteOperations[key], "delete"))
        ].filter(v => v !== null);

        return changes.length ? (
            <React.Fragment>
                <div className="ui divider" />
                <div className="ui secondary blue segment">
                    <div className="ui header">
                        <div className="content">Wykaz zmian</div>
                    </div>
                    {changes}
                </div>
                <button className="ui primary button" onClick={this.onChangesApply}>Zatwierdź</button>
                <button className="ui button" onClick={() => this.setState(this.initialState)}>Anuluj</button>
            </React.Fragment>
        ) : null;
    };

    renderChange = (operation, type) => {
        return (operation) ? (
            <div key={`${type}${operation.userID}`} className={`${type === "add" ? "green" : "red"} content`}>
                {type === "add" ? "Dodano" : "Usunięto"} użytkownika&nbsp;
                <b>{operation.lname} {operation.fname}</b>
            </div>
        ) : null;
    };

    render() {
        return (
            <React.Fragment>
                <div className="edit-external-employees-component ui container">
                    <div className="ui container">
                        <div className="ui header">
                            <div className="content">Pracownicy firmy zewnętrznej: {this.props.externalUnit.name}</div>
                        </div>
                        <div className="ui divider" />
                        {this.props.externalUnit.employees.length ? (
                            <React.Fragment>
                                {this.renderRow()}
                                {this.renderRows()}
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                <div className="ui small header">
                                    <div className="content">Brak pracowników firmy</div>
                                </div>
                                <div className="ui divider" />
                            </React.Fragment>
                        )}
                        {Object.keys(this.state.addOperations).find(key => this.state.addOperations[key]) ? this.renderRow(null, true) : null}
                        {this.renderNewRows()}
                        <Select
                            value={{ label: "Dodaj...", value: null }}
                            onChange={value => this.onNewChange(null, value)}
                            options={[...this.props.usersList.map(u => { return { label: `${u.lname} ${u.fname}`, value: u } })]}
                            placeholder="Użytkownik"
                            noOptionsMessage={() => "Nie znaleziono użytkowników"}
                            maxMenuHeight="400px"
                        />
                        {this.renderChanges()}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    currentUser: state.user.current,
    usersList: state.user.list,
    externalUnit: state.externalUnit.current
});

export default connect(mapStateToProps, { getAllUsers, getExternalUnit, editExternalUnitEmployees })(EditExternalEmployees);